module.exports = __webpack_public_path__ + "img/elemental.883068ba.jpg";